import Workouts from './defaultWorkouts.json';

export const DEFAULT_VARIANT = 'A';

export const DEFAULT_VERSION = 37;

export const DEFAULT_WORKOUTS = Workouts;

export const CONFIG_CACHE_EXPIRATION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours
